export default class CopyLink {
	constructor() {
		this.init();
	}

	init() {
		var url = document.location.href;

		new ClipboardJS( '[data-copy-link]', {
			text: function() {
				return url;
			}
		} );
	}
}
